import React, { useState, useMemo, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { Affix, Space } from "antd";
import NavbarMobile from "./navbar-mobile";
import DrawerBar from "./drawer";

const Navbar: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const labels = useMemo(
    () => [
      { id: 1, title: "Home", path: "/" },
      { id: 2, title: "Travel", path: "/travel" },
      { id: 3, title: "Guides", path: "/guides" },
      { id: 4, title: "Food", path: "/food" },
      { id: 5, title: "Hotels", path: "/hotels" },
      // { id: 6, title: "Privacy", path: "/privacy" },
    ],
    []
  );
  const location = useLocation();

  return (
    <>
      {windowWidth > 800 ? (
        <Affix offsetTop={0}>
          <div className="w-full flex justify-center bg-white">
            <div className="w-full max-w-[1116px] h-[55px] px-8 flex items-center justify-between">
              <ul className="flex items-center justify-between w-full max-w-[486px] text-xs font-semibold text-gray-500 cursor-pointer">
                {labels.map((label, id) => (
                  <Link key={id} to={label.path}>
                    <li
                      key={id}
                      className={`flex items-center justify-center ${
                        location.pathname === label.path
                          ? "text-[#5b68d3]"
                          : "hover:text-[#5b68d3]"
                      }`}
                    >
                      {label.title === "Home" ? (
                        <Link to={label.path}>
                          <Space>
                            <span className="relative flex justify-center items-center h-2 w-2">
                              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#5b68d3] opacity-75"></span>
                              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#5b68d3]"></span>
                            </span>
                            {label.title}
                          </Space>
                        </Link>
                      ) : (
                        <span>{label.title}</span>
                      )}
                    </li>
                  </Link>
                ))}
              </ul>

              <div className="flex flex-shrink-0 items-center space-x-2 ml-2">
                <DrawerBar />
              </div>
            </div>
          </div>
        </Affix>
      ) : (
        <NavbarMobile />
      )}
    </>
  );
};

export default Navbar;
